<template>
  <div>
    <!-- BEGIN PAGE BAR -->
    <div class="page-bar">
      <breadcrumb :crumbs="breadcrumbArray" />
    </div>
    <!-- END PAGE BAR -->

    <!-- BEGIN PAGE TITLE-->
    <h1 class="page-title">
      Order Settings
    </h1>
    <!-- END PAGE TITLE -->
    <div class="note note-info">
      <p>Add and manage order settings for the active store.</p>
    </div>

    <div class="row">
      <div
        v-show="activeLocationId === undefined"
        class="col-md-12"
      >
        <div class="alert center alert-info">
          <h4>No Store Selected</h4>
          <p>Please select a store from the stores panel on the right to view order settings and apply them to the store.</p>
        </div>
      </div>
    </div>

    <!-- BEGIN CREATE -->
    <div
      v-if="activeLocationId !== undefined && orderSettingsToEdit.id === undefined && $root.permissions['stores order_settings update']"
      class="portlet box blue-hoki"
    >
      <div
        class="portlet-title bg-blue-chambray"
        @click="toggleCreatePanel()"
      >
        <div class="caption">
          <i class="fa fa-2x fa-plus-circle" />
          Create Order Settings
        </div>
        <div class="tools">
          <a :class="{'expand': !createNewCollapse, 'collapse': createNewCollapse}" />
        </div>
      </div>
      <div
        class="portlet-body relative-block"
        :class="{'display-hide': createNewCollapse}"
      >
        <form
          v-show="activeLocationId !== undefined"
          role="form"
          @submit.prevent="createOrderSettings()"
        >
          <div class="row">
            <div class="col-md-12">
              <div
                v-show="createErrorMessage.length"
                ref="createErrorMessage"
                class="alert alert-danger"
              >
                <button
                  class="close"
                  data-close="alert"
                  @click.prevent="clearError('createErrorMessage')"
                />
                <span>{{ createErrorMessage }}</span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group form-md-line-input form-md-floating-label">
                <input
                  id="form_control_1"
                  v-model="newOrderSettings.pickup_time_slot"
                  type="text"
                  class="form-control input-sm"
                  :class="{'edited': newOrderSettings.pickup_time_slot.length}"
                >
                <label for="form_control_1">
                  Pickup Time Slot
                </label>
              </div>
              <div class="form-group form-md-line-input form-md-floating-label">
                <input
                  id="form_control_pickup_time_slot_start"
                  v-model="newOrderSettings.pickup_time_slot_start"
                  type="text"
                  class="form-control input-sm"
                  :class="{'edited': newOrderSettings.pickup_time_slot_start.length}"
                >
                <label for="form_control_pickup_time_slot_start">
                  Pickup Time Slot Start
                </label>
              </div>
              <div class="form-group form-md-line-input form-md-floating-label">
                <input
                  id="form_control_pickup_time_slot_duration"
                  v-model="newOrderSettings.pickup_time_slot_duration"
                  type="text"
                  class="form-control input-sm"
                  :class="{'edited': newOrderSettings.pickup_time_slot_duration.length}"
                >
                <label for="form_control_pickup_time_slot_duration">
                  Pickup Time Slot Duration
                </label>
              </div>
              <div class="form-group form-md-line-input form-md-floating-label">
                <input
                  id="form_control_3"
                  v-model="newOrderSettings.pickup_orders_per_slot"
                  type="text"
                  class="form-control input-sm"
                  :class="{'edited': newOrderSettings.pickup_orders_per_slot.length}"
                >
                <label for="form_control_3">
                  Pickup Orders Per Slot
                </label>
              </div>
              <div class="form-group form-md-line-input form-md-floating-label">
                <input
                  id="create_pickup_order_time_cut_off"
                  v-model="newOrderSettings.pickup_order_time_cut_off"
                  type="text"
                  class="form-control input-sm"
                  :class="{'edited': newOrderSettings.pickup_order_time_cut_off.length}"
                >
                <label for="create_pickup_order_time_cut_off">
                  Pickup Order Time Cut Off
                </label>
              </div>
              <div class="form-group form-md-line-input form-md-floating-label">
                <input
                  id="form_control_3"
                  v-model="newOrderSettings.pickup_cancellation_time_cut_off"
                  type="text"
                  class="form-control input-sm"
                  :class="{'edited': newOrderSettings.pickup_cancellation_time_cut_off.length}"
                >
                <label for="form_control_3">
                  Pickup Cancellation Time Cut Off
                </label>
              </div>
              <div class="form-group form-md-line-input form-md-floating-label">
                <label>Pickup Cancellation Enabled</label><br>
                <el-switch
                  v-model="newOrderSettings.pickup_cancellation_enabled"
                  active-color="#0c6"
                  inactive-color="#ff4949"
                  active-value="1"
                  inactive-value="0"
                  active-text="Yes"
                  inactive-text="No"
                />
              </div>

              <div class="form-group form-md-line-input form-md-floating-label">
                <input
                  id="form_control_1"
                  v-model="newOrderSettings.group_order_time_slot"
                  type="text"
                  class="form-control input-sm"
                  :class="{'edited': newOrderSettings.group_order_time_slot.length}"
                >
                <label for="form_control_1">
                  Group Order Time Slot
                </label>
              </div>
              <div class="form-group form-md-line-input form-md-floating-label">
                <input
                  id="form_control_group_order_time_slot_start"
                  v-model="newOrderSettings.group_order_time_slot_start"
                  type="text"
                  class="form-control input-sm"
                  :class="{'edited': newOrderSettings.group_order_time_slot_start.length}"
                >
                <label for="form_control_group_order_time_slot_start">
                  Group Order Time Slot Start
                </label>
              </div>
              <div class="form-group form-md-line-input form-md-floating-label">
                <input
                  id="form_control_group_order_time_slot_duration"
                  v-model="newOrderSettings.group_order_time_slot_duration"
                  type="text"
                  class="form-control input-sm"
                  :class="{'edited': newOrderSettings.group_order_time_slot_duration.length}"
                >
                <label for="form_control_group_order_time_slot_duration">
                  Group Order Time Slot Duration
                </label>
              </div>
              <div class="form-group form-md-line-input form-md-floating-label">
                <input
                  id="form_control_3"
                  v-model="newOrderSettings.group_order_order_time_cut_off"
                  type="text"
                  class="form-control input-sm"
                  :class="{'edited': newOrderSettings.group_order_order_time_cut_off.length}"
                >
                <label for="form_control_3">
                  Group Order Time Cut Off
                </label>
              </div>
              <div class="form-group form-md-line-input form-md-floating-label">
                <input
                  id="form_control_3"
                  v-model="newOrderSettings.group_order_cancellation_time_cut_off"
                  type="text"
                  class="form-control input-sm"
                  :class="{'edited': newOrderSettings.group_order_cancellation_time_cut_off.length}"
                >
                <label for="form_control_3">
                  Group Order Cancellation Time Cut Off
                </label>
              </div>
              <div class="form-group form-md-line-input form-md-floating-label">
                <label>Group Order Cancellation Enabled</label><br>
                <el-switch
                  v-model="newOrderSettings.group_order_cancellation_enabled"
                  active-color="#0c6"
                  inactive-color="#ff4949"
                  active-value="1"
                  inactive-value="0"
                  active-text="Active"
                  inactive-text="Inactive"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group form-md-line-input form-md-floating-label">
                <input
                  id="form_control_1"
                  v-model="newOrderSettings.delivery_time_slot"
                  type="text"
                  class="form-control input-sm"
                  :class="{'edited': newOrderSettings.delivery_time_slot.length}"
                >
                <label for="form_control_1">
                  Delivery Time Slot
                </label>
              </div>
              <div class="form-group form-md-line-input form-md-floating-label">
                <input
                  id="form_control_delivery_time_slot_start"
                  v-model="newOrderSettings.delivery_time_slot_start"
                  type="text"
                  class="form-control input-sm"
                  :class="{'edited': newOrderSettings.delivery_time_slot_start.length}"
                >
                <label for="form_control_delivery_time_slot_start">
                  Delivery Time Slot Start
                </label>
              </div>
              <div class="form-group form-md-line-input form-md-floating-label">
                <input
                  id="form_control_delivery_time_slot_duration"
                  v-model="newOrderSettings.delivery_time_slot_duration"
                  type="text"
                  class="form-control input-sm"
                  :class="{'edited': newOrderSettings.delivery_time_slot_duration.length}"
                >
                <label for="form_control_delivery_time_slot_duration">
                  Delivery Time Slot Duration
                </label>
              </div>
              <div class="form-group form-md-line-input form-md-floating-label">
                <input
                  id="create_delivery_orders_per_slot"
                  v-model="newOrderSettings.delivery_orders_per_slot"
                  type="text"
                  class="form-control input-sm"
                  :class="{'edited': newOrderSettings.delivery_orders_per_slot.length}"
                >
                <label for="create_delivery_orders_per_slot">
                  Delivery Orders Per Slot
                </label>
              </div>
              <div class="form-group form-md-line-input form-md-floating-label">
                <input
                  id="form_control_3"
                  v-model="newOrderSettings.delivery_order_time_cut_off"
                  type="text"
                  class="form-control input-sm"
                  :class="{'edited': newOrderSettings.delivery_order_time_cut_off.length}"
                >
                <label for="form_control_3">
                  Delivery Order Time Cut Off
                </label>
              </div>
              <div class="form-group form-md-line-input form-md-floating-label">
                <input
                  id="form_control_3"
                  v-model="newOrderSettings.delivery_cancellation_time_cut_off"
                  type="text"
                  class="form-control input-sm"
                  :class="{'edited': newOrderSettings.delivery_cancellation_time_cut_off.length}"
                >
                <label for="form_control_3">
                  Delivery Cancellation Time Cut Off
                </label>
              </div>
              <div class="form-group form-md-line-input form-md-floating-label">
                <label>Delivery Cancellation Enabled</label><br>
                <el-switch
                  v-model="newOrderSettings.delivery_cancellation_enabled"
                  active-color="#0c6"
                  inactive-color="#ff4949"
                  active-value="1"
                  inactive-value="0"
                  active-text="Active"
                  inactive-text="Inactive"
                />
              </div>
              <div class="form-group form-md-line-input form-md-floating-label">
                <input
                  id="form_control_1"
                  v-model="newOrderSettings.catering_time_slot"
                  type="text"
                  class="form-control input-sm"
                  :class="{'edited': newOrderSettings.catering_time_slot.length}"
                >
                <label for="form_control_1">
                  Catering Time Slot
                </label>
              </div>
              <div class="form-group form-md-line-input form-md-floating-label">
                <input
                  id="form_control_catering_time_slot_start"
                  v-model="newOrderSettings.catering_time_slot_start"
                  type="text"
                  class="form-control input-sm"
                  :class="{'edited': newOrderSettings.catering_time_slot_start.length}"
                >
                <label for="form_control_catering_time_slot_start">
                  Catering Time Slot Start
                </label>
              </div>
              <div class="form-group form-md-line-input form-md-floating-label">
                <input
                  id="form_control_catering_time_slot_duration"
                  v-model="newOrderSettings.catering_time_slot_duration"
                  type="text"
                  class="form-control input-sm"
                  :class="{'edited': newOrderSettings.catering_time_slot_duration.length}"
                >
                <label for="form_control_catering_time_slot_duration">
                  Catering Time Slot Duration
                </label>
              </div>
              <div class="form-group form-md-line-input form-md-floating-label">
                <input
                  id="form_control_3"
                  v-model="newOrderSettings.catering_order_time_cut_off"
                  type="text"
                  class="form-control input-sm"
                  :class="{'edited': newOrderSettings.catering_order_time_cut_off.length}"
                >
                <label for="form_control_3">
                  Catering Order Time Cut Off
                </label>
              </div>
              <div class="form-group form-md-line-input form-md-floating-label">
                <input
                  id="form_control_3"
                  v-model="newOrderSettings.catering_cancellation_time_cut_off"
                  type="text"
                  class="form-control input-sm"
                  :class="{'edited': newOrderSettings.catering_cancellation_time_cut_off.length}"
                >
                <label for="form_control_3">
                  Catering Cancellation Time Cut Off
                </label>
              </div>
              <div class="form-group form-md-line-input form-md-floating-label">
                <label>Catering Cancellation Enabled</label><br>
                <el-switch
                  v-model="newOrderSettings.catering_cancellation_enabled"
                  active-color="#0c6"
                  inactive-color="#ff4949"
                  active-value="1"
                  inactive-value="0"
                  active-text="Active"
                  inactive-text="Inactive"
                />
              </div>
              <button
                type="submit"
                class="btn blue pull-right"
                :disabled="creating"
              >
                Create
                <i
                  v-show="creating"
                  class="fa fa-spinner fa-pulse fa-fw"
                />
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <!-- END CREATE -->

    <!-- BEGIN LIST -->
    <div v-show="activeLocationId !== undefined">
      <div class="portlet light portlet-fit bordered margin-top-20">
        <div class="portlet-title bg-blue-chambray">
          <div class="menu-image-main">
            <img src="../../../../public/client_logo.png">
          </div>
          <div class="caption">
            <span class="caption-subject font-default bold uppercase">
              Order Settings
            </span>
            <div class="caption-desc font-grey-cascade">
              Create, edit or delete Order Settings for the active store.
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div
            v-show="listErrorMessage.length"
            ref="listErrorMessage"
            class="alert alert-danger"
          >
            <button
              class="close"
              data-close="alert"
              @click="clearError('listErrorMessage')"
            />
            <span>{{ listErrorMessage }}</span>
          </div>
        </div>
        <div class="portlet-body relative-block">
          <loading-screen
            :show="loading"
            :color="'#2C3E50'"
            :display="'inline'"
          />
          <div
            v-if="!loading && orderSettingsToEdit.id !== undefined"
            class="mt-element-list margin-top-15"
          >
            <fieldset :disabled="!$root.permissions['stores order_settings update']">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group form-md-line-input form-md-floating-label">
                    <input
                      id="form_control_1"
                      v-model="orderSettingsToEdit.pickup_time_slot"
                      type="text"
                      class="form-control input-sm"
                      :class="{'edited': orderSettingsToEdit.pickup_time_slot.length}"
                    >
                    <label for="form_control_1">
                      Pickup Time Slot
                    </label>
                  </div>
                  <div class="form-group form-md-line-input form-md-floating-label">
                    <input
                      id="form_control_pickup_time_slot_start"
                      v-model="orderSettingsToEdit.pickup_time_slot_start"
                      type="text"
                      class="form-control input-sm"
                      :class="{'edited': orderSettingsToEdit.pickup_time_slot_start.length}"
                    >
                    <label for="form_control_pickup_time_slot_start">
                      Pickup Time Slot Start
                    </label>
                  </div>
                  <div class="form-group form-md-line-input form-md-floating-label">
                    <input
                      id="form_control_pickup_time_slot_duration"
                      v-model="orderSettingsToEdit.pickup_time_slot_duration"
                      type="text"
                      class="form-control input-sm"
                      :class="{'edited': orderSettingsToEdit.pickup_time_slot_duration.length}"
                    >
                    <label for="form_control_pickup_time_slot_duration">
                      Pickup Time Slot Duration
                    </label>
                  </div>
                  <div class="form-group form-md-line-input form-md-floating-label">
                    <input
                      id="form_control_3"
                      v-model="orderSettingsToEdit.pickup_orders_per_slot"
                      type="text"
                      class="form-control input-sm"
                      :class="{'edited': orderSettingsToEdit.pickup_orders_per_slot.length}"
                    >
                    <label for="form_control_3">
                      Pickup Orders Per Slot
                    </label>
                  </div>
                  <div class="form-group form-md-line-input form-md-floating-label">
                    <input
                      id="create_pickup_order_time_cut_off"
                      v-model="orderSettingsToEdit.pickup_order_time_cut_off"
                      type="text"
                      class="form-control input-sm"
                      :class="{'edited': orderSettingsToEdit.pickup_order_time_cut_off.length}"
                    >
                    <label for="create_pickup_order_time_cut_off">
                      Pickup Order Time Cut Off
                    </label>
                  </div>
                  <div class="form-group form-md-line-input form-md-floating-label">
                    <input
                      id="form_control_3"
                      v-model="orderSettingsToEdit.pickup_cancellation_time_cut_off"
                      type="text"
                      class="form-control input-sm"
                      :class="{'edited': orderSettingsToEdit.pickup_cancellation_time_cut_off.length}"
                    >
                    <label for="form_control_3">
                      Pickup Cancellation Time Cut Off
                    </label>
                  </div>
                  <div class="form-group form-md-line-input form-md-floating-label">
                    <label>Pickup Cancellation Enabled:</label><br>
                    <el-switch
                      v-model="orderSettingsToEdit.pickup_cancellation_enabled"
                      active-color="#0c6"
                      inactive-color="#ff4949"
                      active-value="1"
                      inactive-value="0"
                      active-text="Yes"
                      inactive-text="No"
                      :disabled="!$root.permissions['stores order_settings update']"
                    />
                  </div>
                  <div class="form-group form-md-line-input form-md-floating-label">
                    <input
                      id="form_control_1"
                      v-model="orderSettingsToEdit.group_order_time_slot"
                      type="text"
                      class="form-control input-sm"
                      :class="{'edited': orderSettingsToEdit.group_order_time_slot.length}"
                    >
                    <label for="form_control_1">
                      Group Order Time Slot
                    </label>
                  </div>
                  <div class="form-group form-md-line-input form-md-floating-label">
                    <input
                      id="form_control_group_order_time_slot_start"
                      v-model="orderSettingsToEdit.group_order_time_slot_start"
                      type="text"
                      class="form-control input-sm"
                      :class="{'edited': orderSettingsToEdit.group_order_time_slot_start.length}"
                    >
                    <label for="form_control_group_order_time_slot_start">
                      Group Order Time Slot Start
                    </label>
                  </div>
                  <div class="form-group form-md-line-input form-md-floating-label">
                    <input
                      id="form_control_group_order_time_slot_duration"
                      v-model="orderSettingsToEdit.group_order_time_slot_duration"
                      type="text"
                      class="form-control input-sm"
                      :class="{'edited': orderSettingsToEdit.group_order_time_slot_duration.length}"
                    >
                    <label for="form_control_group_order_time_slot_duration">
                      Group Order Time Slot Duration
                    </label>
                  </div>
                  <div class="form-group form-md-line-input form-md-floating-label">
                    <input
                      id="form_control_3"
                      v-model="orderSettingsToEdit.group_order_order_time_cut_off"
                      type="text"
                      class="form-control input-sm"
                      :class="{'edited': orderSettingsToEdit.group_order_order_time_cut_off.length}"
                    >
                    <label for="form_control_3">
                      Group Order Time Cut Off
                    </label>
                  </div>
                  <div class="form-group form-md-line-input form-md-floating-label">
                    <input
                      id="form_control_3"
                      v-model="orderSettingsToEdit.group_order_cancellation_time_cut_off"
                      type="text"
                      class="form-control input-sm"
                      :class="{'edited': orderSettingsToEdit.group_order_cancellation_time_cut_off.length}"
                    >
                    <label for="form_control_3">
                      Group Order Cancellation Time Cut Off
                    </label>
                  </div>
                  <div class="form-group form-md-line-input form-md-floating-label">
                    <label>Group Order Cancellation Enabled:</label><br>
                    <el-switch
                      v-model="orderSettingsToEdit.group_order_cancellation_enabled"
                      active-color="#0c6"
                      inactive-color="#ff4949"
                      active-value="1"
                      inactive-value="0"
                      active-text="Active"
                      inactive-text="Inactive"
                      :disabled="!$root.permissions['stores order_settings update']"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group form-md-line-input form-md-floating-label">
                    <input
                      id="form_control_1"
                      v-model="orderSettingsToEdit.delivery_time_slot"
                      type="text"
                      class="form-control input-sm"
                      :class="{'edited': orderSettingsToEdit.delivery_time_slot.length}"
                    >
                    <label for="form_control_1">
                      Delivery Time Slot
                    </label>
                  </div>
                  <div class="form-group form-md-line-input form-md-floating-label">
                    <input
                      id="form_control_delivery_time_slot_start"
                      v-model="orderSettingsToEdit.delivery_time_slot_start"
                      type="text"
                      class="form-control input-sm"
                      :class="{'edited': orderSettingsToEdit.delivery_time_slot_start.length}"
                    >
                    <label for="form_control_delivery_time_slot_start">
                      Delivery Time Slot Start
                    </label>
                  </div>
                  <div class="form-group form-md-line-input form-md-floating-label">
                    <input
                      id="form_control_delivery_time_slot_duration"
                      v-model="orderSettingsToEdit.delivery_time_slot_duration"
                      type="text"
                      class="form-control input-sm"
                      :class="{'edited': orderSettingsToEdit.delivery_time_slot_duration.length}"
                    >
                    <label for="form_control_delivery_time_slot_duration">
                      Delivery Time Slot Duration
                    </label>
                  </div>
                  <div class="form-group form-md-line-input form-md-floating-label">
                    <input
                      id="create_delivery_orders_per_slot"
                      v-model="orderSettingsToEdit.delivery_orders_per_slot"
                      type="text"
                      class="form-control input-sm"
                      :class="{'edited': orderSettingsToEdit.delivery_orders_per_slot.length}"
                    >
                    <label for="create_delivery_orders_per_slot">
                      Delivery Orders Per Slot
                    </label>
                  </div>
                  <div class="form-group form-md-line-input form-md-floating-label">
                    <input
                      id="form_control_3"
                      v-model="orderSettingsToEdit.delivery_order_time_cut_off"
                      type="text"
                      class="form-control input-sm"
                      :class="{'edited': orderSettingsToEdit.delivery_order_time_cut_off.length}"
                    >
                    <label for="form_control_3">
                      Delivery Order Time Cut Off
                    </label>
                  </div>
                  <div class="form-group form-md-line-input form-md-floating-label">
                    <input
                      id="form_control_3"
                      v-model="orderSettingsToEdit.delivery_cancellation_time_cut_off"
                      type="text"
                      class="form-control input-sm"
                      :class="{'edited': orderSettingsToEdit.delivery_cancellation_time_cut_off.length}"
                    >
                    <label for="form_control_3">
                      Delivery Cancellation Time Cut Off
                    </label>
                  </div>
                  <div class="form-group form-md-line-input form-md-floating-label">
                    <label>Delivery Cancellation Enabled:</label><br>
                    <el-switch
                      v-model="orderSettingsToEdit.delivery_cancellation_enabled"
                      active-color="#0c6"
                      inactive-color="#ff4949"
                      active-value="1"
                      inactive-value="0"
                      active-text="Active"
                      inactive-text="Inactive"
                      :disabled="!$root.permissions['stores order_settings update']"
                    />
                  </div>
                  <div class="form-group form-md-line-input form-md-floating-label">
                    <input
                      id="form_control_1"
                      v-model="orderSettingsToEdit.catering_time_slot"
                      type="text"
                      class="form-control input-sm"
                      :class="{'edited': orderSettingsToEdit.catering_time_slot.length}"
                    >
                    <label for="form_control_1">
                      Catering Time Slot
                    </label>
                  </div>
                  <div class="form-group form-md-line-input form-md-floating-label">
                    <input
                      id="form_control_catering_time_slot_start"
                      v-model="orderSettingsToEdit.catering_time_slot_start"
                      type="text"
                      class="form-control input-sm"
                      :class="{'edited': orderSettingsToEdit.catering_time_slot_start.length}"
                    >
                    <label for="form_control_catering_time_slot_start">
                      Catering Time Slot Start
                    </label>
                  </div>
                  <div class="form-group form-md-line-input form-md-floating-label">
                    <input
                      id="form_control_catering_time_slot_duration"
                      v-model="orderSettingsToEdit.catering_time_slot_duration"
                      type="text"
                      class="form-control input-sm"
                      :class="{'edited': orderSettingsToEdit.catering_time_slot_duration.length}"
                    >
                    <label for="form_control_catering_time_slot_duration">
                      Catering Time Slot Duration
                    </label>
                  </div>
                  <div class="form-group form-md-line-input form-md-floating-label">
                    <input
                      id="form_control_3"
                      v-model="orderSettingsToEdit.catering_order_time_cut_off"
                      type="text"
                      class="form-control input-sm"
                      :class="{'edited': orderSettingsToEdit.catering_order_time_cut_off.length}"
                    >
                    <label for="form_control_3">
                      Catering Order Time Cut Off
                    </label>
                  </div>
                  <div class="form-group form-md-line-input form-md-floating-label">
                    <input
                      id="form_control_3"
                      v-model="orderSettingsToEdit.catering_cancellation_time_cut_off"
                      type="text"
                      class="form-control input-sm"
                      :class="{'edited': orderSettingsToEdit.catering_cancellation_time_cut_off.length}"
                    >
                    <label for="form_control_3">
                      Catering Cancellation Time Cut Off
                    </label>
                  </div>
                  <div class="form-group form-md-line-input form-md-floating-label">
                    <label>Catering Cancellation Enabled:</label><br>
                    <el-switch
                      v-model="orderSettingsToEdit.catering_cancellation_enabled"
                      active-color="#0c6"
                      inactive-color="#ff4949"
                      active-value="1"
                      inactive-value="0"
                      active-text="Active"
                      inactive-text="Inactive"
                      :disabled="!$root.permissions['stores order_settings update']"
                    />
                  </div>
                </div>
                <div class="col-xs-12 right margin-top-20">
                  <div class="pull-right">
                    <button
                      v-if="$root.permissions['stores order_settings delete']"
                      type="button"
                      class="btn btn-outline blue margin-right-10"
                      @click.stop.prevent="confirmDelete()"
                    >
                      Delete
                    </button>
                    <button
                      v-if="$root.permissions['stores order_settings update']"
                      type="button"
                      class="btn blue"
                      :disabled="updating"
                      @click="updateOrderSettings()"
                    >
                      Save
                      <i
                        v-show="updating"
                        class="fa fa-spinner fa-pulse fa-fw"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
          <div class="margin-top-20">
            <no-results
              :show="!loading && orderSettingsToEdit.id === undefined"
              :type="'order settings'"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- END LIST -->

    <modal
      :show="showDeleteModal"
      effect="fade"
      @closeOnEscape="closeDeleteModal"
    >
      <div
        slot="modal-header"
        class="modal-header center"
      >
        <button
          type="button"
          class="close"
          @click="closeDeleteModal()"
        >
          <span>&times;</span>
        </button>
        <h4 class="modal-title center">
          Delete Order Settings
        </h4>
      </div>
      <div
        slot="modal-body"
        class="modal-body"
      >
        <div
          v-show="deleteErrorMessage.length"
          class="alert alert-danger"
        >
          <button
            ref="deleteErrorMessage"
            class="close"
            @click="clearError('deleteErrorMessage')"
          />
          <span>{{ deleteErrorMessage }}</span>
        </div>
        <div class="col-md-12">
          Are you sure you want to delete order settings for {{ $root.activeLocation.name }}?
        </div>
      </div>
      <div
        slot="modal-footer"
        class="modal-footer clear"
      >
        <button
          type="button"
          class="btn btn-primary"
          :disabled="deleting"
          @click="deleteOrderSettings()"
        >
          Delete
          <i
            v-show="deleting"
            class="fa fa-spinner fa-pulse fa-fw"
          />
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
import Breadcrumb from '@/components/modules/Breadcrumb'
import LoadingScreen from '@/components/modules/LoadingScreen'
import Modal from '@/components/modules/Modal'
import NoResults from '@/components/modules/NoResults'
import OrderSettingsFunctions from '@/controllers/OrderSettings'
import ajaxErrorHandler from '@/controllers/ErrorController'
import { isNonNegativeNumber } from '@/controllers/utils'

export default {
  components: {
    Breadcrumb,
    LoadingScreen,
    Modal,
    NoResults
  },
  data () {
    return {
      breadcrumbArray: [
        { name: 'Menu Manager', link: false },
        { name: 'Order Settings', link: false }
      ],
      createNewCollapse: true,
      creating: false,
      createErrorMessage: '',
      newOrderSettings: {
        pickup_time_slot: '',
        pickup_time_slot_start: '',
        pickup_time_slot_duration: '',
        pickup_orders_per_slot: '',
        pickup_order_time_cut_off: '',
        pickup_cancellation_time_cut_off: '',
        pickup_cancellation_enabled: '0',
        catering_time_slot: '',
        catering_time_slot_start: '',
        catering_time_slot_duration: '',
        catering_order_time_cut_off: '',
        catering_cancellation_time_cut_off: '',
        catering_cancellation_enabled: '0',
        delivery_time_slot: '',
        delivery_time_slot_start: '',
        delivery_time_slot_duration: '',
        delivery_orders_per_slot: '',
        delivery_order_time_cut_off: '',
        delivery_cancellation_time_cut_off: '',
        delivery_cancellation_enabled: '0',
        group_order_time_slot: '',
        group_order_time_slot_start: '',
        group_order_time_slot_duration: '',
        group_order_order_time_cut_off: '',
        group_order_cancellation_time_cut_off: '',
        group_order_cancellation_enabled: '0'
      },
      listErrorMessage: '',
      loading: false,
      updating: false,
      orderSettingsToEdit: {
        pickup_time_slot: '',
        pickup_time_slot_start: '',
        pickup_time_slot_duration: '',
        pickup_orders_per_slot: '',
        pickup_order_time_cut_off: '',
        pickup_cancellation_time_cut_off: '',
        pickup_cancellation_enabled: '0',
        catering_time_slot: '',
        catering_time_slot_start: '',
        catering_time_slot_duration: '',
        catering_order_time_cut_off: '',
        catering_cancellation_time_cut_off: '',
        catering_cancellation_enabled: '0',
        delivery_time_slot: '',
        delivery_time_slot_start: '',
        delivery_time_slot_duration: '',
        delivery_orders_per_slot: '',
        delivery_order_time_cut_off: '',
        delivery_cancellation_time_cut_off: '',
        delivery_cancellation_enabled: '0',
        group_order_time_slot: '',
        group_order_time_slot_start: '',
        group_order_time_slot_duration: '',
        group_order_order_time_cut_off: '',
        group_order_cancellation_time_cut_off: '',
        group_order_cancellation_enabled: '0'
      },
      showDeleteModal: false,
      deleting: false,
      deleteErrorMessage: ''
    }
  },
  computed: {
    activeLocationId: function () {
      return this.$root.activeLocation.id
    }
  },
  watch: {
    activeLocationId: function (newId) {
      if (newId !== undefined) {
        this.getOrderSettingsForStore()
      }
    }
  },
  created () {
    if (this.activeLocationId) {
      this.getOrderSettingsForStore()
    }
  },
  methods: {
    /**
     * To toggle the create tier panel, initially set to closed
     * @function
     * @returns {undefined}
     */
    toggleCreatePanel () {
      this.createNewCollapse = !this.createNewCollapse
    },
    /**
     * To clear the current error.
     * @function
     * @param {object} errorMessageName - The error message to be cleared.
     * @returns {undefined}
     */
    clearError (errorMessageName) {
      this[errorMessageName] = ''
    },
    /**
     * To check if the OrderSettings data is valid before submitting to the backend.
     * @function
     * @returns {object} A promise that will validate the input form
     */
    validatenewOrderSettingsData () {
      var _this = this
      return new Promise(function (resolve, reject) {
        if (!_this.newOrderSettings.pickup_time_slot) {
          reject('Pickup Time Slot cannot be blank')
        } else if (!isNonNegativeNumber(_this.newOrderSettings.pickup_time_slot)) {
          reject('Pickup Time Slot must be zero or more')
        } else if (!_this.newOrderSettings.pickup_time_slot_start) {
          reject('Pickup Time Slot Start cannot be blank')
        } else if (!isNonNegativeNumber(_this.newOrderSettings.pickup_time_slot_start)) {
          reject('Pickup Time Slot Start must be zero or more')
        } else if (!_this.newOrderSettings.pickup_time_slot_duration) {
          reject('Pickup Time Slot Duration cannot be blank')
        } else if (!isNonNegativeNumber(_this.newOrderSettings.pickup_time_slot_duration)) {
          reject('Pickup Time Slot Duration must be zero or more')
        } else if (!_this.newOrderSettings.pickup_orders_per_slot) {
          reject('Pickup Orders Per Slot cannot be blank')
        } else if (!isNonNegativeNumber(_this.newOrderSettings.pickup_orders_per_slot)) {
          reject('Pickup Orders Per Slot must be zero or more')
        } else if (!_this.newOrderSettings.pickup_order_time_cut_off) {
          reject('Pickup Order Time Cut Off cannot be blank')
        } else if (!isNonNegativeNumber(_this.newOrderSettings.pickup_order_time_cut_off)) {
          reject('Pickup Order Time Cut Off must be zero or more')
        } else if (!_this.newOrderSettings.pickup_cancellation_time_cut_off) {
          reject('Pickup Cancellation Time Cut Off cannot be blank')
        } else if (!isNonNegativeNumber(_this.newOrderSettings.pickup_cancellation_time_cut_off)) {
          reject('Pickup Cancellation Time Cut Off must be zero or more')
        } else if (!_this.newOrderSettings.group_order_time_slot) {
          reject('Group Order Time Slot cannot be blank')
        } else if (!isNonNegativeNumber(_this.newOrderSettings.group_order_time_slot)) {
          reject('Group Order Time Slot must be zero or more')
        } else if (!_this.newOrderSettings.group_order_time_slot_start) {
          reject('Group Order Time Slot Start cannot be blank')
        } else if (!isNonNegativeNumber(_this.newOrderSettings.group_order_time_slot_start)) {
          reject('Group Order Time Slot Start must be zero or more')
        } else if (!_this.newOrderSettings.group_order_time_slot_duration) {
          reject('Group Order Time Slot Duration cannot be blank')
        } else if (!isNonNegativeNumber(_this.newOrderSettings.group_order_time_slot_duration)) {
          reject('Group Order Time Slot Duration must be zero or more')
        } else if (!_this.newOrderSettings.group_order_order_time_cut_off) {
          reject('Group Order Time Cut Off cannot be blank')
        } else if (!isNonNegativeNumber(_this.newOrderSettings.group_order_order_time_cut_off)) {
          reject('Group Order Time Cut Off must be zero or more')
        } else if (!_this.newOrderSettings.group_order_cancellation_time_cut_off) {
          reject('Group Order Cancellation Time Cut Off cannot be blank')
        } else if (!isNonNegativeNumber(_this.newOrderSettings.group_order_cancellation_time_cut_off)) {
          reject('Group Order Cancellation Time Cut Off must be zero or more')
        } else if (!_this.newOrderSettings.delivery_time_slot) {
          reject('Delivery Time Slot cannot be blank')
        } else if (!isNonNegativeNumber(_this.newOrderSettings.delivery_time_slot)) {
          reject('Delivery Time Slot must be zero or more')
        } else if (!_this.newOrderSettings.delivery_time_slot_start) {
          reject('Delivery Time Slot Start cannot be blank')
        } else if (!isNonNegativeNumber(_this.newOrderSettings.delivery_time_slot_start)) {
          reject('Delivery Time Slot Start must be zero or more')
        } else if (!_this.newOrderSettings.delivery_time_slot_duration) {
          reject('Delivery Time Slot Duration cannot be blank')
        } else if (!isNonNegativeNumber(_this.newOrderSettings.delivery_time_slot_duration)) {
          reject('Delivery Time Slot Duration must be zero or more')
        } else if (!_this.newOrderSettings.delivery_orders_per_slot) {
          reject('Delivery Orders Per Slot cannot be blank')
        } else if (!isNonNegativeNumber(_this.newOrderSettings.delivery_orders_per_slot)) {
          reject('Delivery Orders Per Slot must be zero or more')
        } else if (!_this.newOrderSettings.delivery_order_time_cut_off) {
          reject('Delivery Order Time Cut Off cannot be blank')
        } else if (!isNonNegativeNumber(_this.newOrderSettings.delivery_order_time_cut_off)) {
          reject('Delivery Order Time Cut Off must be zero or more')
        } else if (!_this.newOrderSettings.delivery_cancellation_time_cut_off) {
          reject('Delivery Cancellation Time Cut Off cannot be blank')
        } else if (!isNonNegativeNumber(_this.newOrderSettings.delivery_cancellation_time_cut_off)) {
          reject('Delivery Cancellation Time Cut Off must be zero or more')
        } else if (!_this.newOrderSettings.catering_time_slot) {
          reject('Catering Time Slot cannot be blank')
        } else if (!isNonNegativeNumber(_this.newOrderSettings.catering_time_slot)) {
          reject('Catering Time Slot must be zero or more')
        } else if (!_this.newOrderSettings.catering_time_slot_start) {
          reject('Catering Time Slot Start cannot be blank')
        } else if (!isNonNegativeNumber(_this.newOrderSettings.catering_time_slot_start)) {
          reject('Catering Time Slot Start must be zero or more')
        } else if (!_this.newOrderSettings.catering_time_slot_duration) {
          reject('Catering Time Slot Duration cannot be blank')
        } else if (!isNonNegativeNumber(_this.newOrderSettings.catering_time_slot_duration)) {
          reject('Catering Time Slot Duration must be zero or more')
        } else if (!_this.newOrderSettings.catering_order_time_cut_off) {
          reject('Catering Order Time Cut Off cannot be blank')
        } else if (!isNonNegativeNumber(_this.newOrderSettings.catering_order_time_cut_off)) {
          reject('Catering Order Time Cut Off must be zero or more')
        } else if (!_this.newOrderSettings.catering_cancellation_time_cut_off) {
          reject('Catering Cancellation Time Cut Off cannot be blank')
        } else if (!isNonNegativeNumber(_this.newOrderSettings.catering_cancellation_time_cut_off)) {
          reject('Catering Cancellation Time Cut Off must be zero or more')
        }
        resolve('Hurray')
      })
    },
    /**
     * To create a new OrderSettings.
     * @function
     * @returns {object} A promise that will validate the input form
     */
    createOrderSettings () {
      var _this = this
      _this.clearError('createErrorMessage')

      let payload = { ...this.newOrderSettings }
      payload.location_id = this.$root.activeLocation.id

      return _this
        .validatenewOrderSettingsData()
        .then(response => {
          _this.creating = true
          OrderSettingsFunctions.setOrderSettings(
            _this.$root.appId,
            _this.$root.appSecret,
            _this.$root.userToken,
            payload
          )
            .then(response => {
              _this.showCreateSuccess(response.payload)
              _this.newOrderSettings = _this.blankOrderSettings()
              _this.getOrderSettingsForStore()
            })
            .catch(reason => {
              ajaxErrorHandler({
                reason,
                errorText: 'We could not create order settings',
                errorName: 'createErrorMessage',
                vue: _this
              })
            })
            .finally(() => {
              _this.creating = false
            })
        })
        .catch(reason => {
          _this.createErrorMessage = reason
        })
    },
    /**
     * To update order settings.
     * @function
     * @returns {object} A promise that will validate the input form
     */
    updateOrderSettings () {
      var _this = this
      _this.clearError('listErrorMessage')

      return _this
        .validateEditedOrderSettingsData()
        .then(response => {
          _this.updating = true
          OrderSettingsFunctions.setOrderSettings(
            _this.$root.appId,
            _this.$root.appSecret,
            _this.$root.userToken,
            _this.orderSettingsToEdit
          )
            .then(response => {
              _this.showEditSuccess(response.payload)
              _this.getOrderSettingsForStore()
            })
            .catch(reason => {
              ajaxErrorHandler({
                reason,
                errorText: 'We could not create order settings',
                errorName: 'listErrorMessage',
                vue: _this
              })
            })
            .finally(() => {
              _this.updating = false
            })
        })
        .catch(reason => {
          _this.listErrorMessage = reason
        })
    },
    /**
     * To notify user of the outcome of the call
     * @function
     * @param {object} payload - The payload object from the server response
     * @returns {undefined}
     */
    showCreateSuccess (payload = {}) {
      let title = 'Success'
      let text = 'The Order Settings have been created'
      let type = 'success'

      if (payload && payload.pending_approval) {
        title = 'Approval Required'
        text = 'The Order Settings have been sent for approval'
        type = 'info'
      }

      this.$swal({
        title,
        text,
        type
      })
    },
    /**
     * To clear the new OrderSetting form.
     * @function
     * @returns {undefined}
     */
    blankOrderSettings () {
      return {
        pickup_time_slot: '',
        pickup_time_slot_start: '',
        pickup_time_slot_duration: '',
        pickup_orders_per_slot: '',
        pickup_order_time_cut_off: '',
        pickup_cancellation_time_cut_off: '',
        pickup_cancellation_enabled: '',
        catering_time_slot: '',
        catering_time_slot_start: '',
        catering_time_slot_duration: '',
        catering_order_time_cut_off: '',
        catering_cancellation_time_cut_off: '',
        catering_cancellation_enabled: '',
        delivery_time_slot: '',
        delivery_time_slot_start: '',
        delivery_time_slot_duration: '',
        delivery_orders_per_slot: '',
        delivery_order_time_cut_off: '',
        delivery_cancellation_time_cut_off: '',
        delivery_cancellation_enabled: '',
        group_order_time_slot: '',
        group_order_time_slot_start: '',
        group_order_time_slot_duration: '',
        group_order_order_time_cut_off: '',
        group_order_cancellation_time_cut_off: '',
        group_order_cancellation_enabled: ''
      }
    },
    /**
     * To get a list of OrderSettings for the current active store.
     * @function
     * @returns {object} - A promise that will either return an error message or perform an action.
     */
    getOrderSettingsForStore () {
      this.loading = true
      var _this = this

      return OrderSettingsFunctions.getOrderSettingsForStore(
        _this.$root.appId,
        _this.$root.appSecret,
        _this.$root.userToken,
        _this.$root.activeLocation.id
      )
        .then(response => {
          _this.loading = false
          Object.keys(response.payload).forEach(key => {
            _this.orderSettingsToEdit[key] = String(
              response.payload[key]
            )
          })
        })
        .catch(reason => {
          _this.loading = false
          if (
            reason.responseJSON.message ===
            'Location order configurations for selected location doesnt exist.'
          ) {
            _this.orderSettingsToEdit = _this.blankOrderSettings()
            return
          }
          ajaxErrorHandler({
            reason,
            errorText: 'We could not fetch order settings',
            errorName: 'listErrorMessage',
            vue: _this
          })
        })
    },
    /**
     * To check if the order data is valid before submitting to the backend.
     * @function
     * @returns {object} A promise that will validate the input form
     */
    validateEditedOrderSettingsData () {
      var _this = this
      return new Promise(function (resolve, reject) {
        if (!_this.orderSettingsToEdit.pickup_time_slot) {
          reject('Pickup Time Slot cannot be blank')
        } else if (!isNonNegativeNumber(_this.orderSettingsToEdit.pickup_time_slot)) {
          reject('Pickup Time Slot must be zero or more')
        } else if (!_this.orderSettingsToEdit.pickup_time_slot_start) {
          reject('Pickup Time Slot Start cannot be blank')
        } else if (!isNonNegativeNumber(_this.orderSettingsToEdit.pickup_time_slot_start)) {
          reject('Pickup Time Slot Start must be zero or more')
        } else if (!_this.orderSettingsToEdit.pickup_time_slot_duration) {
          reject('Pickup Time Slot Duration cannot be blank')
        } else if (!isNonNegativeNumber(_this.orderSettingsToEdit.pickup_time_slot_duration)) {
          reject('Pickup Time Slot Duration must be zero or more')
        } else if (!_this.orderSettingsToEdit.pickup_orders_per_slot) {
          reject('Pickup Orders Per Slot cannot be blank')
        } else if (!isNonNegativeNumber(_this.orderSettingsToEdit.pickup_orders_per_slot)) {
          reject('Pickup Orders Per Slot must be zero or more')
        } else if (!_this.orderSettingsToEdit.pickup_order_time_cut_off) {
          reject('Pickup Order Time Cut Off cannot be blank')
        } else if (!isNonNegativeNumber(_this.orderSettingsToEdit.pickup_order_time_cut_off)) {
          reject('Pickup Order Time Cut Off must be zero or more')
        } else if (!_this.orderSettingsToEdit.pickup_cancellation_time_cut_off) {
          reject('Pickup Cancellation Time Cut Off cannot be blank')
        } else if (!isNonNegativeNumber(_this.orderSettingsToEdit.pickup_cancellation_time_cut_off)) {
          reject('Pickup Cancellation Time Cut Off must be zero or more')
        } else if (!_this.orderSettingsToEdit.group_order_time_slot) {
          reject('Group Order Time Slot cannot be blank')
        } else if (!isNonNegativeNumber(_this.orderSettingsToEdit.group_order_time_slot)) {
          reject('Group Order Time Slot must be zero or more')
        } else if (!_this.orderSettingsToEdit.group_order_time_slot_start) {
          reject('Group Order Time Slot Start cannot be blank')
        } else if (!isNonNegativeNumber(_this.orderSettingsToEdit.group_order_time_slot_start)) {
          reject('Group Order Time Slot Start must be zero or more')
        } else if (!_this.orderSettingsToEdit.group_order_time_slot_duration) {
          reject('Group Order Time Slot Duration cannot be blank')
        } else if (!isNonNegativeNumber(_this.orderSettingsToEdit.group_order_time_slot_duration)) {
          reject('Group Order Time Slot Duration must be zero or more')
        } else if (!_this.orderSettingsToEdit.group_order_order_time_cut_off) {
          reject('Group Order Time Cut Off cannot be blank')
        } else if (!isNonNegativeNumber(_this.orderSettingsToEdit.group_order_order_time_cut_off)) {
          reject('Group Order Time Cut Off must be zero or more')
        } else if (!_this.orderSettingsToEdit.group_order_cancellation_time_cut_off) {
          reject('Group Order Cancellation Time Cut Off cannot be blank')
        } else if (!isNonNegativeNumber(_this.orderSettingsToEdit.group_order_cancellation_time_cut_off)) {
          reject('Group Order Cancellation Time Cut Off must be zero or more')
        } else if (!_this.orderSettingsToEdit.delivery_time_slot) {
          reject('Delivery Time Slot cannot be blank')
        } else if (!isNonNegativeNumber(_this.orderSettingsToEdit.delivery_time_slot)) {
          reject('Delivery Time Slot must be zero or more')
        } else if (!_this.orderSettingsToEdit.delivery_time_slot_start) {
          reject('Delivery Time Slot Start cannot be blank')
        } else if (!isNonNegativeNumber(_this.orderSettingsToEdit.delivery_time_slot_start)) {
          reject('Delivery Time Slot Start must be zero or more')
        } else if (!_this.orderSettingsToEdit.delivery_time_slot_duration) {
          reject('Delivery Time Slot Duration cannot be blank')
        } else if (!isNonNegativeNumber(_this.orderSettingsToEdit.delivery_time_slot_duration)) {
          reject('Delivery Time Slot Duration must be zero or more')
        } else if (!_this.orderSettingsToEdit.delivery_orders_per_slot) {
          reject('Delivery Orders Per Slot cannot be blank')
        } else if (!isNonNegativeNumber(_this.orderSettingsToEdit.delivery_orders_per_slot)) {
          reject('Delivery Orders Per Slot must be zero or more')
        } else if (!_this.orderSettingsToEdit.delivery_order_time_cut_off) {
          reject('Delivery Order Time Cut Off cannot be blank')
        } else if (!isNonNegativeNumber(_this.orderSettingsToEdit.delivery_order_time_cut_off)) {
          reject('Delivery Order Time Cut Off must be zero or more')
        } else if (!_this.orderSettingsToEdit.delivery_cancellation_time_cut_off) {
          reject('Delivery Cancellation Time Cut Off cannot be blank')
        } else if (!isNonNegativeNumber(_this.orderSettingsToEdit.delivery_cancellation_time_cut_off)) {
          reject('Delivery Cancellation Time Cut Off must be zero or more')
        } else if (!_this.orderSettingsToEdit.catering_time_slot) {
          reject('Catering Time Slot cannot be blank')
        } else if (!isNonNegativeNumber(_this.orderSettingsToEdit.catering_time_slot)) {
          reject('Catering Time Slot must be zero or more')
        } else if (!_this.orderSettingsToEdit.catering_time_slot_start) {
          reject('Catering Time Slot Start cannot be blank')
        } else if (!isNonNegativeNumber(_this.orderSettingsToEdit.catering_time_slot_start)) {
          reject('Catering Time Slot Start must be zero or more')
        } else if (!_this.orderSettingsToEdit.catering_time_slot_duration) {
          reject('Catering Time Slot Duration cannot be blank')
        } else if (!isNonNegativeNumber(_this.orderSettingsToEdit.catering_time_slot_duration)) {
          reject('Catering Time Slot Duration must be zero or more')
        } else if (!_this.orderSettingsToEdit.catering_order_time_cut_off) {
          reject('Catering Order Time Cut Off cannot be blank')
        } else if (!isNonNegativeNumber(_this.orderSettingsToEdit.catering_order_time_cut_off)) {
          reject('Catering Order Time Cut Off must be zero or more')
        } else if (!_this.orderSettingsToEdit.catering_cancellation_time_cut_off) {
          reject('Catering Cancellation Time Cut Off cannot be blank')
        } else if (!isNonNegativeNumber(_this.orderSettingsToEdit.catering_cancellation_time_cut_off)) {
          reject('Catering Cancellation Time Cut Off must be zero or more')
        }
        resolve('Hurray')
      })
    },
    /**
     * To notify user of the outcome of the call
     * @function
     * @param {object} payload - The payload object from the server response
     * @returns {undefined}
     */
    showEditSuccess (payload = {}) {
      let title = 'Success'
      let text = 'The Order Settings have been saved'
      let type = 'success'

      if (payload && payload.pending_approval) {
        title = 'Approval Required'
        text = 'The changes have been sent for approval'
        type = 'info'
      }

      this.$swal({
        title,
        text,
        type
      })
    },
    /**
     * To reset the edit form
     * @function
     * @returns {undefined}
     */
    resetEdit () {
      // TODO
    },
    /**
     * To display the modal for deleting an order.
     * @function
     * @returns {undefined}
     */
    confirmDelete () {
      this.showDeleteModal = true
    },
    /**
     * To close the modal for deleting a promotion and remove that promotion from DOM.
     * @function
     * @returns {undefined}
     */
    deleteOrderSettings () {
      this.deleting = true
      this.clearError('deleteErrorMessage')
      var _this = this
      return OrderSettingsFunctions.deleteOrderSettings(
        _this.$root.appId,
        _this.$root.appSecret,
        _this.$root.userToken,
        _this.$root.activeLocation.id
      )
        .then(response => {
          if (response.code === 200 && response.status === 'ok') {
            _this.getOrderSettingsForStore()
            _this.closeDeleteModal()
            _this.showDeleteSuccess(response.payload)
          }
        })
        .catch(reason => {
          ajaxErrorHandler({
            reason,
            errorText: `We could not delete order settings`,
            errorName: 'deleteErrorMessage',
            vue: _this
          })
        })
        .finally(() => {
          _this.deleting = false
        })
    },
    /**
     * To notify user of the outcome of the call
     * @function
     * @param {object} payload - The payload object from the server response
     * @returns {undefined}
     */
    showDeleteSuccess (payload = {}) {
      let title = 'Success'
      let text = 'The Order Settings have been deleted'
      let type = 'success'

      if (payload && payload.pending_approval) {
        title = 'Approval Required'
        text = 'The removal has been sent for approval'
        type = 'info'
      }

      this.$swal({
        title,
        text,
        type
      })
    },
    /**
     * To close the delete modal.
     * @function
     * @returns {undefined}
     */
    closeDeleteModal () {
      this.showDeleteModal = false
    }
  }
}
</script>
